module.exports = __webpack_public_path__ + "static/media/event12.78367378.jpeg";